module.exports = __webpack_public_path__ + "img/30_22.d37fafd5.png";